<template>
  <layout-block :has-border="false" :width="width" margin="48px 16px">
    <layout-block-head :title="competition.title" :style="{ marginTop: flex ? '62px' : 0 }" />
    <ui-legend :label="competition.legend" v-if="competition.legend" />
    <layout-block-section margin="16px 0">
      <table style="width: 100%; border-collapse: collapse;">
        <tr
          v-for="(c, idx) in competition.data"
          :key="`competition-${idx}`"
          :style="{ borderBottom: idx + 1 < competition.data.length ? '2px solid #E5E8EE' : 'none' }"
        >
          <td style="padding: 0; vertical-align: top;">
            <table :style="{ color: c.brand ? '#397CFF' : '#06152F' }" style="width: 100%; border-collapse: collapse;">
              <tr>
                <td style="position: relative; padding: 4px 0 0 0;">
                  <div
                    v-if="c.brand"
                    style="position: absolute; top: 0; left:0; border-top:20px solid  #397CFF; border-right: 20px solid transparent; width: 0; height: 0; "
                  ></div>
                  <span style="padding-right: 4px; padding-left: 16px; font-size: 24px; font-weight: bold;">
                    {{ c.rating_value }}
                  </span>
                  <span style="padding-right: 8px; font-size: 20px; font-weight:600;" height="30" align="left">
                    {{ truncate(c.name, 13) }}
                  </span>
                </td>
              </tr>
              <tr>
                <td style="padding: 0 0 16px 16px; color: #53627C; font-size:12px; font-weight:500;">
                  {{ $t('report.legendNoteDistribution').toUpperCase() }}
                  <table
                    style="margin-top:4px; border-radius: 2px; width: 100%; height: 10px; overflow: hidden; border-collapse: collapse;"
                  >
                    <template v-for="(d, j) in c.distribution">
                      <td
                        :key="`${idx}-${j}-distribution`"
                        :style="{
                          backgroundColor: competition.colors[j],
                          width: `${d}%`,
                          display: d !== 0 ? 'table-cell' : 'none',
                        }"
                        style="padding-left:8px;"
                      ></td>
                      <td
                        :key="`${idx}-${j}-separator`"
                        v-if="j + 1 < c.distribution.length"
                        style="background-color: #FFF;"
                      ></td>
                    </template>
                  </table>
                </td>
              </tr>
            </table>
          </td>
          <td style="padding: 0 0 0 16px; vertical-align: top;">
            <table style="width: 100%; border-collapse: collapse;">
              <tr>
                <td align="right" style="padding: 12px 16px 0 0; color: #06152F; font-size: 18px; font-weight:500;">
                  {{ kFormatter(c.rating_count) }}
                  <img
                    src="https://gatoreviews.s3.eu-west-3.amazonaws.com/common/emails/new/comment.png"
                    width="16px"
                    style="margin: auto ;"
                  />
                </td>
              </tr>
              <tr>
                <td style="padding: 4px 16px 0 0;">
                  <ui-trend :trend="c.trend" />
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </layout-block-section>
    <ui-button
      :label="competition.cta.label"
      :href="competition.cta.url"
      v-if="competition.cta && hasCta"
      margin="52px 0 0 0"
    />
  </layout-block>
</template>

<script>
import LayoutBlock from '@/components/Layout/Block.vue'
import LayoutBlockHead from '@/components/Layout/Block/Head.vue'
import LayoutBlockSection from '@/components/Layout/Block/Section.vue'
import UiButton from '@/components/UI/Button.vue'
import UiLegend from '@/components/UI/Legend.vue'
import UiTrend from '@/components/UI/Trend.vue'

export default {
  name: 'ReportCompetition',
  components: {
    LayoutBlock,
    LayoutBlockHead,
    LayoutBlockSection,
    UiButton,
    UiLegend,
    UiTrend,
  },
  props: {
    width: {
      type: String,
      default: 'auto',
    },
    competition: {
      type: Object,
      required: true,
    },
    hasCta: {
      type: Boolean,
      default: true,
    },
    flex: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    truncate(source, size) {
      return source.length > size ? source.slice(0, size - 1) + '…' : source
    },
    kFormatter(num) {
      return Math.abs(num) > 999 ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + 'k' : num
    },
  },
}
</script>
